const intOpts: Intl.NumberFormatOptions = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
}

/** Nearest ₹100 for report display only (underlying totals unchanged). */
export function roundInrForReportDisplay(v: number): number {
  return Math.round(v / 100) * 100
}

function trimDecimal(s: string): string {
  return s.replace(/\.0$/, '')
}

/**
 * Abbreviated ₹ for display: Cr (≥1 cr), L (≥1 lac), K (≥1k), else full amount.
 * Expects values already rounded to ₹100 when coming from report pipeline.
 */
export function formatAbbreviatedInr(display: number): string {
  const v = display
  if (v === 0) return '₹0'

  if (v >= 10_000_000) {
    const x = v / 10_000_000
    return `₹${trimDecimal(x.toFixed(1))}Cr`
  }
  if (v >= 100_000) {
    const x = v / 100_000
    return `₹${trimDecimal(x.toFixed(1))}L`
  }
  if (v >= 1_000) {
    const x = v / 1_000
    const s = Number.isInteger(x) ? String(x) : trimDecimal(x.toFixed(1))
    return `₹${s}K`
  }

  return `₹${v.toLocaleString('en-IN', intOpts)}`
}

/** Table cells: zero shows as em dash. */
export function formatInrReportCell(v: number): string {
  if (v === 0) return '—'
  return formatAbbreviatedInr(roundInrForReportDisplay(v))
}

/** Chart axis / tooltip */
export function formatInrReportAmount(v: number): string {
  return formatAbbreviatedInr(roundInrForReportDisplay(Number(v)))
}
